import Head from "@/Molecules/Inertia/Head";
import {PageProps} from '@/types';
import {Pagination as PaginationType} from '@/types/Pagination.d';
import Search from "@/Atoms/Search/Search";
import Tile from "@/Molecules/Article/Tile";
import {Article} from "@/types/Article.d";
import Pagination from "@/Molecules/Pagination/Pagination";
import StickyContainer from "@/Molecules/StickyContainer/StickyContainer";
import {FormEvent, useState} from "react";
import Commercial, {CommercialPageType, CommercialType} from "@/Atoms/Commercial";
import Page from "@/Pages/Page";
import TileList from "@/Molecules/Article/TileList";
import {relativeRoute} from "@/helpers/relativeRoute";
import {router} from "@inertiajs/react";

interface Pagination<T> {
  items: T[],
  page: number,
  pages: number
}

export default function Articles(
  {
    baseUrl,
    title,
    articles,
    category,
    search: initSearch,
  }: PageProps<{
    baseUrl: string,
    title?: string,
    category?: string,
    search?: string,
    articles: Pagination<Article>
  }>) {


  const [search, setSearch] = useState(initSearch)

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const route = relativeRoute('articles', {category: category, search: search})
      router.visit(route)
    }

    const handlePaginate = (page: number) => {
      const route = relativeRoute('articles', {category: category, search: search, page: page})
      router.visit(route)
    }

  const formattedTitle = title || 'Verhalen';
  return (
      <Page title={formattedTitle} pageType={CommercialPageType.ArticleList} adUnit={'articles'}>



        <section className={'bg-beige'}>

          <div className="container md:flex justify-between">
            <h1>{formattedTitle}</h1>
            <div className="md:flex gap-4">

              <form onSubmit={handleSubmit}>
                <Search
                  // isClearable
                  placeholder={'Zoeken...'}
                  value={search ?? ''}
                  onChange={(input) => setSearch(input)}
                />
              </form>
            </div>
          </div>

        </section>

        <section>
          <div className={'container'}>
            {/*<StickyContainer component={<Commercial type={CommercialType.HalfPageSkyscraper} top/>}>*/}
              <TileList>
                {articles.items.length === 0 && ('Geen resultaten')}
                {articles.items.map((article, index) => <Tile key={index} article={article}/>)}
              </TileList>
            {/*</StickyContainer>*/}
            <Pagination page={articles.page} pages={articles.pages} onChange={(page) => handlePaginate(page)} />
          </div>
        </section>

      </Page>
    );
}
